import { Box, Card, CircularProgress, Divider, Modal } from "@mui/material"
import React from "react"
import HeaderUI from "../../SubComponent/Header/UI/Browser/Header"
import HomeDispatch from "./model"
import HomeState from "../../State/HomeState"
import ProfileUI from "../../SubComponent/Profile/UI/Browser/Profile"
import RouterUI from "../../SubComponent/Main/Router/UI/Browser/Router"

class Home extends React.PureComponent<{}>{
    componentDidMount(): void {
        let dispatcher: HomeDispatch = (this.props as any).dispatcher
        dispatcher.fetch()
    }
    render() {
        let state: HomeState = (this.props as any).state

        return (
            <Box flexDirection='column' display="flex">
                <div>
                    {/* HEADER    */}
                    <HeaderUI />
                    {/* HEADER    */}


                    <Modal open={state.loading} onClose={() => { }}>
                        <Box sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 'fit-content',
                            bgcolor: "background.paper",
                            border: "2px solid #000",
                            boxShadow: 24,
                            p: 4,
                        }} >
                            <CircularProgress />
                        </Box>
                    </Modal>

                    <Box height="100vh" display="flex" flexDirection="column">
                        <Card variant="outlined" sx={{ height: '100%', borderRadius: '24px', borderColor: 'transparent', bgcolor: '#f5f5f5', ml: 2, mr: 2, mt: '78px', mb: 2, p: 1 }} >
                            <Box flexDirection='row' sx={{ height: '100%', width: '100%' }} display="flex">
                                <Box sx={{ width: '20%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <ProfileUI />
                                </Box>

                                <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                                <Box sx={{ width: '80%', height: '100%' }}>
                                    <RouterUI />
                                </Box>
                            </Box>
                        </Card>
                    </Box>
                </div >
            </Box>
        )
    }
}

export default Home